import React, { Suspense } from 'react'
import Loader from 'components/Loader/index.js'
import SDKProvider from 'lib/scanVIN'

export const withSuspense = (Component) => (
  <Suspense fallback={<Loader />}>
    <Component />
  </Suspense>
)

export const withVinProviders = (Component) => (
  <Suspense fallback={<Loader />}>
    <SDKProvider>
      <Component />
    </SDKProvider>
  </Suspense>
)
